/**
 * 流程应用 API
 * @author lincl
 * @date 2022-12-19
 */
import request from '../../utils/request'
import { delCache } from '../../utils/cache'

const CACHE_NAME = 'flowApp' // 缓存名称

/**
 * 查询全部
 * @returns {Promise<AxiosResponse<T>>}
 */
export function listFlowApp(flowFormFlag, templateFlag, industry) {
  return request({
    url: `/flow/app/list`,
    method: 'get',
    params: { flowFormFlag, templateFlag, industry }
  })
}

/**
 * 分页查询
 * @param params 查询条件
 */
export function queryFlowApp(params) {
  return request({
    url: `/flow/app`,
    method: 'get',
    params
  })
}

/**
 * 按ID查询
 * @param flowAppId 记录ID
 */
export function getFlowApp(flowAppId) {
  return request({
    url: `/flow/app/` + flowAppId,
    method: 'get'
  })
}

/**
 * 新增记录
 * @param data
 */
export function addFlowApp(data) {
  delCache(CACHE_NAME)
  return request({
    url: `/flow/app`,
    method: 'post',
    data
  })
}

/**
 * 更新记录
 * @param data
 */
export function updFlowApp(data) {
  delCache(CACHE_NAME)
  return request({
    url: `/flow/app`,
    method: 'put',
    data
  })
}

/**
 * 删除记录
 * @param flowAppId 记录ID
 */
export function delFlowApp(flowAppId) {
  delCache(CACHE_NAME)
  return request({
    url: `/flow/app/` + flowAppId,
    method: 'delete'
  })
}

/**
 * 状态切换
 * @param params
 * @returns {AxiosPromise}
 */
export function statusFlowApp(params) {
  return request({
    url: `/flow/app/status`,
    method: 'put',
    params
  })
}

/**
 * 上架范围
 * @param data
 */
export function addFlowAppScope(data) {
  delCache(CACHE_NAME)
  return request({
    url: `/flow/app/scope`,
    method: 'post',
    data
  })
}

/**
 * 安装应用
 * @param data
 */
export function installFlowApp(flowAppId) {
  delCache(CACHE_NAME)
  return request({
    url: `/flow/app/install`,
    method: 'post',
    params: { flowAppId }
  })
}
